import React from 'react';
import { Menu } from '@blueprintjs/core';

import { useI18n } from 'i18n';
import NavLinkItem from './NavLinkItem';
import { AllRoutes } from 'constants/routes';

import './settingsMenu.scss';

export const TepMenu = () => {
  const { fc } = useI18n();

  const menuItems = [
    { title: fc('VETA TEP management'), url: AllRoutes.TepManagement },
    { title: fc('TEP devices management'), url: AllRoutes.TepDevicesManagement },
    { title: fc('clients notifications'), url: AllRoutes.TepClientNotifications },
    { title: fc('Enforcement Officers notifications'), url: AllRoutes.TepOfficersNotifications },
  ];

  return (
    <Menu className="settings-menu">
      {menuItems.map(({ title, url }, index) => (
        <NavLinkItem key={index} to={url}>
          {title}
        </NavLinkItem>
      ))}
    </Menu>
  );
};
